import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {IGetDataReturn, IHttpSetting} from '../interface/dataset-params';
import {GlobalObjectService} from '../class/global-obj';
import {IFormSaveStructure} from '../interface/form-structure';
import {LocalDbService} from '../class/localdb';

@Injectable({
    providedIn: 'root'
})
export class HttpFormService {

    setting: IHttpSetting;

    constructor(private http: HttpClient) {

    }

    toHttpParams(params) {
        return Object.getOwnPropertyNames(params)
            .reduce((p, key) => p.set(params[key].key, params[key].value), new HttpParams());
    }


    public callCR(FORM_ID: any, formSaveData: IFormSaveStructure, triggerId: any)
        : Observable<IGetDataReturn> {
        const body = {
            func: '_call',
            _id: FORM_ID,
            trigger_id: triggerId,
            formdata: formSaveData
        };
        const setting: IHttpSetting = GlobalObjectService.getVar('setting');
        const url = setting.urls.object_url.replace(/\/+$/, '');
        return this.http.post(url + '/formActions',
            JSON.stringify(body))
            .pipe(map((response: any) => {
                return response;
            }));
    }

    public formSave(FORM_ID: any, formSaveData: IFormSaveStructure)
        : Observable<IGetDataReturn> {
        const body = {
            func: '_save',
            _id: FORM_ID,
            formdata: formSaveData
        };
        const setting: IHttpSetting = GlobalObjectService.getVar('setting');
        const url = setting.urls.object_url.replace(/\/+$/, '');
        return this.http.post(url + '/formActions',
            JSON.stringify(body))
            .pipe(map((response: any) => {
                return response;
            }));
    }

    public formStructure(FORM_ID: any)
        : Observable<IGetDataReturn> {
        const body = {
            func: '_info',
            _id: FORM_ID
        };



        const setting: IHttpSetting = GlobalObjectService.getVar('setting');
        const url = setting.urls.object_url.replace(/\/+$/, '');
        return this.http.post(url + '/formActions',
            JSON.stringify(body))
            .pipe(map((response: any) => {
                return response;
            }));
    }

    public formFileManagerStructure(setting: IHttpSetting, FORM_ID: any, datasetId: any)
        : Observable<IGetDataReturn> {
        const body = {
            func: '_file_manager',
            _id: FORM_ID,
            dsid: datasetId
        };
        const url = setting.urls.object_url.replace(/\/+$/, '');
        return this.http.post(url + '/formActions',
            JSON.stringify(body))
            .pipe(map((response: any) => {
                return response;
            }));
    }

    public uploadFile(formData: any = [])
        : Observable<IGetDataReturn> {
        const setting: IHttpSetting = GlobalObjectService.getVar('setting');
        const url = setting.urls.object_url.replace(/\/+$/, '');
        /*const httpOptions = {
            headers: new HttpHeaders({enctype: 'multipart/form-data'})
        };
        httpOptions.headers.delete('Content-Type');*/

        formData.func = '_upload';
        return this.http.post(
            url + '/formfileupload', formData
        ).pipe(map((res: any) => {
            return res;
        }));

    }

    public fileDelete(FORM_ID: any, fileId: any)
        : Observable<IGetDataReturn> {

        const setting: IHttpSetting = GlobalObjectService.getVar('setting');
        const url = setting.urls.object_url.replace(/\/+$/, '');

        const body = {
            func: '_file_delete',
            _id: FORM_ID,
            file_id: fileId
        };
        return this.http.post(url + '/formActions',
            JSON.stringify(body))
            .pipe(map((response: any) => {
                return response;
            }));
    }


    public recordFiles(datasetId: number, recordId: number, typeList)
        : Observable<IGetDataReturn> {
        const body = {
            func: '_record_files',
            _id: datasetId,
            rid: recordId,
            tlist: typeList
        };
        const setting: IHttpSetting = GlobalObjectService.getVar('setting');
        const url = setting.urls.object_url.replace(/\/+$/, '');

        return this.http.post(url + '/dsactions',
            JSON.stringify(body))
            .pipe(map((response: any) => {
                return response;
            }));
    }


}
